<template>
    <main  class="blue-grey lighten-5">
        <div class="fondo-personalizado-in">
            <img :src="imagenFondoIn" v-if="gettedVideo">
        </div>
        <div v-show="barra" class="progress">
            
            <div class="indeterminate"></div>
            
        </div>
        
        <div v-show="!barra" class="barra-invisible"></div>


      <router-view v-slot="{ Component, route }" class="main-container" >
        <transition name="fade">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>

<!--        <h1 @click="sendNotification">asd</h1>-->
        
        <footer class="page-footer" :style="{'background-color': accentColor }">
            <div class="footer-copyright" :style="{'background-color': accentColor }">
                <div class="container ">© {{ year }} F&F Soluciones
                  <a  href="https://fyf.mx/AvisoDePrivacidad" target="_blank" class="white-text ">
                    Aviso de privacidad

                  </a>
                  <a href="#!" class="white-text  right">Develop and Design</a>
                </div>
            </div>
        </footer>
    </main>
</template>

<script>
  
  import {mapState} from 'vuex'
  import {setTheme} from '@/api/api'
  import {sendNotification} from '@/api/firebase'

  export default {
    name: 'app',
      data(){
        return{
            gettedVideo: false,
          year: new Date().getFullYear()
        }
      },
    computed: {
      ...mapState(['accentColor', 'primaryColor', 'darkenColor', 'barra', 'imagenFondoIn'])
    },
    methods:{
      sendNotification(){
        sendNotification().then(resp=>{
          console.log(resp)
        }).catch(error =>{
          console.log(error)
        })
      }
    },
    mounted() {
        if (this.imagenFondoIn.length > 1) this.gettedVideo = true
        setTheme(document, this.primaryColor, this.darkenColor, this.accentColor)
    }
  }
</script>

<style>
    body {
        display: flex;
        min-height: 100vh;
        flex-direction: column;
    }

    main {
        flex: 1 0 auto;
    }



    .progress {
        height: 5px;
        position: fixed;
        background-color: #95b1c1;
        margin: 0 0 0 0;
        z-index: 1010;
    }

    .barra-invisible {
        height: 6px;
        position: fixed;
    }

    #toast-container {
        max-width: 40%;
    }


    .page-footer {
        z-index: 100;
        bottom: 0;
        position: fixed;
        width: 100%;
        color: white;
        height: 50px;
        padding: 0;
    }
    .collection .collection-item{
        border-bottom: 1px solid rgba(100,100,100,0.2)
    }
    .fondo-personalizado-in {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 20%;
        width: 80%;
        Height: 100%;
    }
    .fondo-personalizado-in img {
        width: 100%;
        height: 100%;
    }
    .main-container{
        position: relative;
    }

    .titulo{
        font-size: 2.5em;
        display: block;
        margin-top: 12px;
        font-family: "Roboto", serif;
        font-weight: lighter;
    }

    .m-0{
        margin: 0 !important;
    }

    .p-0{
        padding: 0 !important;
    }

    .p-1{
        padding: 1rem !important;
    }

    .pl-03{
        padding-left: .3rem !important;
    }

    .pr-03{
        padding-right: .3rem !important;
    }

    .p-2{
        padding: 2rem !important;
    }

    .p-3{
        padding: 3rem !important;
    }

    .fs-08{
        font-size: 0.8rem;
    }

    .fs-09{
        font-size: 0.9rem;
    }

    .tabs .tab a:focus, .tabs .tab a:focus.active {
        background-color: rgba(178, 209, 246, 0.2);
    }
    .tabs .tab a:hover, .tabs .tab a.active{
        background-color: transparent;
        color: #399976;
    }
    .tabs .tab a{
        color: #a0dec9;
    }
    .tabs .indicator {
        background-color: #a0dec9;
    }

    @media (max-width: 800px) {
        .fondo-personalizado-in {
            left: 0;
            width: 100%;
        }

        .fs-08{
            font-size: 0.7rem;
        }

        .fs-09{
            font-size: 0.8rem;
        }
    }
    .material-symbols-outlined {
      line-height: normal !important;
    }
    .color-demo{
      color: #1e4ea0;
    }
</style>
